import { RenderingManager } from "@babylonjs/core/Rendering/renderingManager.js";
export var DcRenderingGroup;
(function (DcRenderingGroup) {
    DcRenderingGroup[DcRenderingGroup["default"] = 0] = "default";
    DcRenderingGroup[DcRenderingGroup["galleryItemPreviews"] = 1] = "galleryItemPreviews";
    DcRenderingGroup[DcRenderingGroup["galleryItems"] = 2] = "galleryItems";
    DcRenderingGroup[DcRenderingGroup["behindDialogs"] = 3] = "behindDialogs";
    DcRenderingGroup[DcRenderingGroup["dialogs"] = 4] = "dialogs";
    DcRenderingGroup[DcRenderingGroup["topDialogs"] = 5] = "topDialogs";
    DcRenderingGroup[DcRenderingGroup["messageDialogs"] = 6] = "messageDialogs";
    DcRenderingGroup[DcRenderingGroup["aboveDialogs"] = 7] = "aboveDialogs";
    DcRenderingGroup[DcRenderingGroup["complimentDialogs"] = 8] = "complimentDialogs";
    DcRenderingGroup[DcRenderingGroup["topmostDialogs"] = 9] = "topmostDialogs";
    DcRenderingGroup[DcRenderingGroup["menuAnimations"] = 10] = "menuAnimations";
    DcRenderingGroup[DcRenderingGroup["pointerAndLaser"] = 11] = "pointerAndLaser";
    DcRenderingGroup[DcRenderingGroup["fadingSkybox"] = 12] = "fadingSkybox";
    DcRenderingGroup[DcRenderingGroup["logo"] = 13] = "logo";
})(DcRenderingGroup || (DcRenderingGroup = {}));
RenderingManager.MAX_RENDERINGGROUPS = DcRenderingGroup.logo + 1;
